import { useState, useEffect, useRef, useMemo } from "react";
import ButtonComponent from "../../ButtonComponent";
import ButtonBooking from "../../ButtonComponent";
import BoxMember from "../../LoginComponent/BoxMember";
import User from "../../LoginComponent/User";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutSuccess } from "../../../actions";
import "./style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as farHeart } from "@fortawesome/free-regular-svg-icons";
import { loadWishlistAction } from "../../../actions";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useLocalStorage } from "../../../hooks/useLocalStorage";

const NavigationTopComponent = (props) => {
    const { userData } = useLocalStorage();
    const { emitWishlists, timer, setLock, availableRoom, cookies } = props;
    const node = useRef(null);
    const path = window.location.pathname;
    const admin = JSON.parse(localStorage.getItem("auth"));
    const [toggle, setToggle] = useState(false);
    const [showBoxMember, setShowBoxMember] = useState(false);
    const [showwishlist, setShowWishlist] = useState(false);
    const [showUser, setShowUser] = useState({ phoneBtn: "", phoneShow: "" });
    const dispatch = useDispatch();
    const auth = cookies.get("authToken");
    const { t, i18n } = useTranslation();
    let userWishlists = useSelector((state) => state.wishlist);

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    // useEffect(() => {
    //     if (showwishlist) {
    //         const fetchWishlist = async () => {
    //             const wishlists = await axios.post("/api/getWishlistByUsername", {
    //                 username: JSON.parse(localStorage.getItem("auth")).user,
    //             });
    //             // console.log(
    //             //     JSON.stringify(wishlists.data.sort((a, b) => (a.unit > b.unit ? 1 : -1))),
    //             //     JSON.stringify(userWishlists.sort((a, b) => (a.unit > b.unit ? 1 : -1))),
    //             //     JSON.stringify(wishlists.data.sort((a, b) => (a.unit > b.unit ? 1 : -1))) ===
    //             //         JSON.stringify(userWishlists.sort((a, b) => (a.unit > b.unit ? 1 : -1)))
    //             // );
    //             if (
    //                 JSON.stringify(wishlists.data.sort((a, b) => (a.unit > b.unit ? 1 : -1))) !==
    //                 JSON.stringify(userWishlists.sort((a, b) => (a.unit > b.unit ? 1 : -1)))
    //             ) {
    //                 dispatch(loadWishlistAction(wishlists.data));
    //             }
    //         };
    //         fetchWishlist();
    //     }
    // }, [showwishlist]);

    // useMemo(() => {
    //     if (JSON.parse(localStorage.getItem("auth"))) {
    //         let phoneNumber = JSON.parse(localStorage.getItem("auth")).phoneNumber;
    //         let phoneBtn = 0; //phoneNumber.slice(phoneNumber.length - 4, phoneNumber.length);
    //         setShowUser({ phoneBtn: phoneBtn, phoneShow: "******" + phoneBtn });
    //     }
    // }, []);

    const useOutsideClick = (ref, callback) => {
        const handleClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                callback();
            }
        };

        useEffect(() => {
            document.addEventListener("click", handleClick);

            return () => {
                document.removeEventListener("click", handleClick);
            };
        });
    };

    useOutsideClick(node, () => {
        if (showBoxMember) setShowBoxMember(false);
    });

    // const checkReload = (e) => {
    //     var pathArray = window.location.pathname.split("/");
    //     let text = t("alert_check_payment");

    //     if (pathArray[1] == "payment" && window.confirm(text) !== true) {
    //         e.preventDefault();
    //     }
    // };

    // const checkReloadByLink = (e, href) => {
    //     var pathArray = window.location.pathname.split("/");
    //     let text = t("alert_check_payment");

    //     if (pathArray[1] == "payment" && window.confirm(text) !== true) {
    //         e.preventDefault();
    //     } else {
    //         window.location = href;
    //     }
    // };
    let location = useLocation();

    return (
        <>
            <nav
                style={{
                    backgroundColor: `${props.colorBackground}`,
                    width:
                        path === `/login` ||
                        path === `/registration` ||
                        path === `/forget-password` ||
                        path.indexOf(`/verify-account`) === 0 ||
                        path.indexOf(`/reset/`) === 0 ||
                        path === `/`
                            ? "100%"
                            : "calc(100% - 200px)",
                    left: "unset",
                    right: 0,
                }}
                className="navigation-top-component"
            >
                <a href={`/`}>
                    {/* <img src={`/img/logo-` + t("lang") + `-trans-b.png`} alt="" srcSet="" /> */}
                    <h2>MBOG Core Concepts: Metabolic Bone Disorders and Geriatric Care</h2>
                </a>
                <div className="wrapper" ref={node}>
                    <ul className="group-link">
                        {userData && userData.role === "super_admin" && (
                            <>
                                {/* <li>
                                    <Link
                                        className={location.pathname === "/users/teacher" ? "active" : ""}
                                        to="/users/teacher"
                                    >
                                        รายชื่อผู้สอน
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        className={location.pathname === "/users/student" ? "active" : ""}
                                        to="/users/student"
                                    >
                                        รายชื่อผู้เรียน
                                    </Link>
                                </li> */}
                                {/* <li>
                                    <a
                                        style={{ color: `${props.colorMenu}` }}
                                        href={`/dashboard`}
                                        onClick={(e) => checkReload(e)}
                                    >
                                        {t("unit_matrix")}
                                    </a>
                                </li>
                                <li>
                                    <a
                                        style={{ color: `${props.colorMenu}` }}
                                        href={`/compare`}
                                        onClick={(e) => checkReload(e)}
                                    >
                                        {t("nav_compare")}
                                    </a>
                                </li>
                                <li
                                    style={{
                                        color: `${props.colorMenu}`,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                    onClick={() => {
                                        setShowWishlist(!showwishlist);
                                        setShowBoxMember(false);
                                        setToggle(false);
                                    }}
                                >
                                    <p style={{ color: `${props.colorMenu}` }}>{t("nav_fav")}</p>
                                    <div style={{ width: "20px", height: "20px", marginLeft: "5px", display: "flex" }}>
                                        <FontAwesomeIcon
                                            icon={farHeart}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                color: "#0000FF",
                                            }}
                                        />
                                    </div>
                                </li> */}
                            </>
                        )}
                        {/* <li>
                            <a
                                style={{ color: `${props.colorMenu}` }}
                                href={`/#project-information`}
                                onClick={(e) => checkReload(e)}
                            >
                                {t("nav_project_info")}
                            </a>
                        </li>
                        <li>
                            <a
                                style={{ color: `${props.colorMenu}` }}
                                href={`/#booking-guide`}
                                onClick={(e) => checkReload(e)}
                            >
                                {t("nav_booking_info")}
                            </a>
                        </li> */}
                    </ul>
                    <ul className="group-btn">
                        {/* {auth && path !== `/dashboard` && (
                            <li className="btn-booking">
                                <ButtonBooking
                                    btnTitle={t("btn_book_now")}
                                    colorTitle={props.colorButtonText}
                                    colorBackground={props.colorButton}
                                    onClick={(e) => checkReloadByLink(e, `/dashboard`)}
                                />
                            </li>
                        )} */}

                        {path !== `/login` && path !== `/registration` && !auth && (
                            <>
                                <li className="mobile">
                                    <ButtonComponent
                                        btnTitle={t("btn_register")}
                                        colorTitle={props.colorButtonText}
                                        colorBackground={props.colorButton}
                                        onClick={() => (window.location = `/registration`)}
                                        moreClass="button-login"
                                    />
                                </li>
                                <li className="desktop">
                                    <ButtonComponent
                                        btnTitle={t("nav_log_in")}
                                        colorTitle={props.colorButtonText}
                                        colorBackground={props.colorButton}
                                        onClick={() => (window.location = `/login`)}
                                        moreClass="button-login"
                                    />
                                </li>
                            </>
                        )}

                        {auth && (
                            <li className="btn-user">
                                <ButtonComponent
                                    btnLoginTitle={`${JSON.parse(localStorage.getItem("auth")).user} : ${
                                        JSON.parse(localStorage.getItem("auth")).role
                                    }`}
                                    colorTitle={props.colorButtonText}
                                    icon="" //icon/ic-user-2.svg
                                    svgIcon="/sprite.svg#icon-user-3-white"
                                    colorBackground={props.colorButton}
                                    onClick={() => setShowBoxMember(!showBoxMember)}
                                    moreClass="button-user"
                                />
                            </li>
                        )}
                    </ul>
                    <label htmlFor="" className="btn-menu" onClick={() => setToggle(!toggle)}>
                        <span
                            style={{
                                transform: `${toggle ? "rotate(45deg)" : "rotate(0deg)"}`,
                                top: `${toggle ? "50%" : 0}`,
                            }}
                        ></span>
                        <span style={{ opacity: `${toggle ? 0 : 1}` }}></span>
                        <span
                            style={{
                                transform: `${toggle ? "rotate(-45deg)" : "rotate(0deg)"}`,
                                top: `${toggle ? "50%" : "100%"}`,
                            }}
                        ></span>
                    </label>
                    {auth && (
                        <div className={showBoxMember ? "box-member active" : "box-member"}>
                            {/* <User
                                svgIcon="/sprite.svg#icon-user-black"
                                name={`ssss`}
                                email={JSON.parse(localStorage.getItem("auth")).user}
                            /> */}
                            <ul>
                                <li>
                                    <a
                                        href="/users/edit"
                                        className={`${window.location.pathname == `/profile` && "active"}`}
                                        // onClick={(e) => (checkReload(e), setShowBoxMember(false))}
                                    >
                                        แก้ไขข้อมูลผู้ใช้
                                    </a>
                                </li>
                                {/* <li>
                                    <a
                                        href="/history"
                                        className={`${window.location.pathname == `/history` && "active"}`}
                                        onClick={(e) => (checkReload(e), setShowBoxMember(false))}
                                    >
                                        {t("nav_purchase")}
                                    </a>
                                </li> */}
                                {/* <li>
                                    <a
                                        href="/change-password"
                                        className={`${window.location.pathname == `/change-password` && "active"}`}
                                        // onClick={(e) => (checkReload(e), setShowBoxMember(false))}
                                    >
                                        {t("nav_change_password")}
                                    </a>
                                </li> */}
                                {/* {admin && admin.role == "admin" && (
                                    <li>
                                        <a
                                            href="/admin-config"
                                            className={`${window.location.pathname == `/admin-config` && "active"}`}
                                            onClick={(e) => (checkReload(e), setShowBoxMember(false))}
                                        >
                                            {t("nav_admin_config")}
                                        </a>
                                    </li>
                                )} */}
                            </ul>
                            <button
                            // onClick={() => {
                            //     cookies.remove("authToken");
                            //     dispatch(logoutSuccess());
                            //     window.location = ``;
                            // }}
                            >
                                <Link to="/logout">{t("nav_log_out")}</Link>
                            </button>
                        </div>
                    )}
                </div>
            </nav>
            {toggle && (
                <>
                    <div className="overlay"></div>
                    <div className="menu-expand">
                        {auth && (
                            <User
                                svgIcon="/sprite.svg#icon-user-black"
                                name={showUser.phoneShow}
                                email={JSON.parse(localStorage.getItem("auth")).user}
                            />
                        )}

                        {auth && (
                            <>
                                <ul>
                                    <li>
                                        <a
                                            href="/users/edit"
                                            className={`${window.location.pathname == `/profile` && "active"}`}
                                            // onClick={(e) => (checkReload(e), setShowBoxMember(false))}
                                        >
                                            แก้ไขข้อมูลผู้ใช้
                                        </a>
                                    </li>
                                </ul>
                                <button
                                // onClick={() => {
                                //     cookies.remove("authToken");
                                //     dispatch(logoutSuccess());
                                //     window.location = ``;
                                // }}
                                >
                                    <Link to="/logout">{t("nav_log_out")}</Link>
                                </button>
                            </>
                        )}
                    </div>
                </>
            )}
            {/* {auth && (
                <Wishlists
                    emitWishlists={emitWishlists}
                    showwishlist={showwishlist}
                    timer={timer}
                    setLock={setLock}
                    availableRoom={availableRoom}
                    setShowWishlist={setShowWishlist}
                />
            )} */}
        </>
    );
};

export default NavigationTopComponent;
